/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Consistent_For_3to6mInputs */

const en_us2_onboarding_experience_consistent_for_3to6m = /** @type {(inputs: Onboarding_Experience_Consistent_For_3to6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 to 6 months`)
};

const pt_br2_onboarding_experience_consistent_for_3to6m = /** @type {(inputs: Onboarding_Experience_Consistent_For_3to6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 3 a 6 meses`)
};

const es_419_onboarding_experience_consistent_for_3to6m = /** @type {(inputs: Onboarding_Experience_Consistent_For_3to6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 3 a 6 meses`)
};

const pt_pt2_onboarding_experience_consistent_for_3to6m = /** @type {(inputs: Onboarding_Experience_Consistent_For_3to6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 3 a 6 meses`)
};

const fr_fr2_onboarding_experience_consistent_for_3to6m = /** @type {(inputs: Onboarding_Experience_Consistent_For_3to6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 à 6 mois`)
};

const de_de2_onboarding_experience_consistent_for_3to6m = /** @type {(inputs: Onboarding_Experience_Consistent_For_3to6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 bis 6 Monate`)
};

const it_it2_onboarding_experience_consistent_for_3to6m = /** @type {(inputs: Onboarding_Experience_Consistent_For_3to6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 3 a 6 mesi`)
};

/**
* | output |
* | --- |
* | "3 to 6 months" |
*
* @param {Onboarding_Experience_Consistent_For_3to6mInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_consistent_for_3to6m = /** @type {((inputs?: Onboarding_Experience_Consistent_For_3to6mInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Consistent_For_3to6mInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_consistent_for_3to6m(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_consistent_for_3to6m(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_consistent_for_3to6m(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_consistent_for_3to6m(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_consistent_for_3to6m(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_consistent_for_3to6m(inputs)
	return en_us2_onboarding_experience_consistent_for_3to6m(inputs)
});
export { onboarding_experience_consistent_for_3to6m as "onboarding.experience_consistent_for.3to6m" }